var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceIconRadio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "place_icon_radio_bg",
    d: "M14 25.25C20.2132 25.25 25.25 20.2132 25.25 14C25.25 7.78679 20.2132 2.75 14 2.75C7.7868 2.75 2.75 7.78679 2.75 14C2.75 20.2132 7.7868 25.25 14 25.25ZM26.375 14C26.375 20.8345 20.8345 26.375 14 26.375C7.16548 26.375 1.625 20.8345 1.625 14C1.625 7.16547 7.16548 1.625 14 1.625C20.8345 1.625 26.375 7.16547 26.375 14Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "place_icon_radio_circle",
    cx: 14,
    cy: 14,
    r: 4.5
  })));
}
export default SvgPlaceIconRadio;